export default () : string | null => localStorage.getItem('authToken') || sessionStorage.getItem('authToken')
